import React, { useState, useEffect, useRef } from "react";
import RichTextEditor from "react-rte";

function TrueFalse({ item, updateItem, lang }) {
  const [correctAnswer, setCorrectAnswer] = useState(item.contents?.a);
  const [editorState, setEditorState] = useState(
    RichTextEditor.createValueFromString(item.contents?.q ? item.contents?.q[lang.code] : "", "html")
  );
  const posFeedbackRef = useRef();
  const negFeedbackRef = useRef();

  useEffect(() => {
    setEditorState(RichTextEditor.createValueFromString(item.contents?.q?.[lang.code] || "", "html"));
  }, [lang]);

  function handleEditorValueChange(value) {
    setEditorState(value);
    let temp = item;

    if (value.toString("html") === "<p><br></p>") {
      temp.contents.q[lang.code] = "";
    } else {
      temp.contents.q[lang.code] = value.toString("html");
    }
    updateItem({ ...temp });
  }

  function updateFeedback() {
    let temp = { ...item.contents.feedback };

    // if the corresponding text field is empty, don't even create the object key
    temp[lang.code] = {
      ...(posFeedbackRef.current.value && { pos: posFeedbackRef.current.value }),
      ...(negFeedbackRef.current.value && { neg: negFeedbackRef.current.value }),
    };

    updateItem({
      ...item,
      // if the resulting temp object is empty (no pos or neg feedback), send a nullish value
      contents: {
        ...item.contents,
        feedback: Object.keys(temp).length === 0 ? null : temp,
      },
    });
  }

  function updateCorrectAnswer(value) {
    setCorrectAnswer(value);
    updateItem({
      ...item,
      contents: {
        ...item.contents,
        a: value,
      },
    });
  }

  return (
    <div className="QM-question__contents-editor" id={item.type}>
      <div className="QM-question__main-properties">
        <div className="QM-question__question">
          <p>Question</p>
          <RichTextEditor value={editorState} onChange={handleEditorValueChange} />
        </div>
        <div className="QM-question__answer-list">
          <div className="QM-question__answer-list-label">
            <p>Answer</p>
          </div>
          <div className="QM-question__answer-radio-buttons">
            <label>
              <input type="radio" name="truefalse" checked={correctAnswer} onChange={() => updateCorrectAnswer(true)} />
              True
            </label>
            <label>
              <input
                type="radio"
                name="truefalse"
                checked={!correctAnswer}
                onChange={() => updateCorrectAnswer(false)}
              />
              False
            </label>
          </div>
        </div>
        <div className="QM__feedback-options">
          <p>Feedback (optional)</p>
          <label htmlFor="correct-answer-feedback">Correct: </label>
          <input
            ref={posFeedbackRef}
            id="correct-answer-feedback"
            type="text"
            placeholder={`E.g. "That's right! In fact, tardigrades can survive even in the cold vacuum of space!"`}
            value={item.contents.feedback?.[lang.code]?.pos || ""}
            onChange={updateFeedback}
          />
          <label htmlFor="incorrect-answer-feedback">Incorrect: </label>
          <input
            ref={negFeedbackRef}
            id="incorrect-answer-feedback"
            type="text"
            placeholder={`E.g. "Sorry! Remember that the dividend goes in the 'house' when doing long division."`}
            value={item.contents.feedback?.[lang.code]?.neg || ""}
            onChange={updateFeedback}
          />
        </div>
      </div>
    </div>
  );
}

export default TrueFalse;
